import InvoicesComponent from "features/companies/invoices";

export const InvoicesPage = () => (
    // TODO move all of this components logic here once new navigation enabled for all!
    <InvoicesComponent />
);
